const API_URL = process.env.REACT_APP_API_URL || "https://backend-hueniai.onrender.com"; // "https://aichatbothueni-backend.onrender.com";

export default API_URL;
